module.exports = __webpack_public_path__ + "media/mypage/images/icons/credit-cards/discover-cc1bd3df2975e9fc6dfb56cf81dfbbcc.png";